import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PenSvg from "../../assets/icons/PenSvg";
import Refresh from "../../assets/icons/Refresh";
import ModalStructure from "../ModalStructure";
import SeasonBlockCard from "./SeasonBlockCard";
import TableInput from "../TableInput";
import { updateBlock } from "../../services/seasons";
import {
  changeIsoDateToInputFormat,
  dateIsAfter,
  dateIsBetween,
  getPreviousDay,
} from "../../utils/timeFuncs";
import { CgSortAz, CgSortZa } from "react-icons/cg";
import { version } from "react-dom";
import { TbEyeEdit } from "react-icons/tb";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";

//IMPORTANTE: En el panel de payload se puede ver la fecha afectada por la zona horaria.
//para verificar la fecha correcta usar timezone:"UTC" en los dates, o verificar
//la fecha directamente en la shell de mongo

const tableHeader = [
  "Bloque",
  "Intervalo(días)",
  "Fecha de registro",
  "Fecha fin",
]; //cabecera tabla
const blockInfoProps = ["name", "interval", "initDate", "endDate"]; //columnas por fila. solo seleccionar las props necesarias. size = header size

const SeasonTable = ({ data, supplies, updateVD, updateParentProps }) => {
  //const [data, setData] = useState(_data); //copia local de la info de temporada
  const [sortType, setSortType] = useState("default"); //o reversed
  const [sortedColumn, setSortedColumn] = useState(-1); //
  const [sortChange, setSortChange] = useState(0);
  const [showModal, setShowModal] = useState(false); //modal de bloque
  const [selectedBlock, setSelectedBlock] = useState(0); //bloque seleccionado
  const [updatingBlock, setUpdatingBlock] = useState(false); //estado actualizando bloque
  const [validateUpdates, setValidateUpdates] = useState([]); //validar actualizaciones de bloques
  const [blocksChanges, setBlocksChanges] = useState([]);

  useEffect(() => {
    let temp = data.blocks.map((b) => {
      return {
        block: b.id,
        hasChanged: false,
      };
    });
    setBlocksChanges(temp);
  }, []);

  const unsavedChanges = () => {
    return blocksChanges.some((b) => b.hasChanged);
  };

  //======================================Optimizaciones=========================================
  // Nuevo estado para el input activo
  const [activeInput, setActiveInput] = useState(null);

  // Función para manejar el clic en la celda
  const handleCellClick = (rowPos, col) => {
    setActiveInput((prev) => {
      // Si la celda clickeada es la misma que la activa, no cambiar el estado
      if (prev && prev.rowPos === rowPos && prev.col === col) {
        return prev; // No hace nada, mantiene la celda activa
      }

      // Si es una celda diferente, activa la nueva celda
      return { rowPos, col };
    });
  };
  //=============================================================================================

  //===================verficar estado de fechas de bloques=====================
  useEffect(() => {
    //determinar si es valido actualizar un bloque o guardar temporada

    const result = data.blocks.map((block) => {
      if (
        dateIsBetween(data.initDate, data.endDate, block.endDate) &&
        dateIsBetween(data.initDate, data.endDate, block.initDate)
      ) {
        return true;
      } else return false;
    });
    setValidateUpdates(result);
    //updParentProps(data); //actualza la data del componente padre con los cambios locales
    IS_LOCAL_ENV && console.log(data.status);
  }, [data]);
  //================habilitar boton de guardado de temporada==================
  useEffect(() => {
    //actualizar estado de validacion del componente padre
    //para habilitar o deshablir el boton de guardar temporada
    let temp = [...validateUpdates];
    const b = temp.every((val) => val === true);
    //TAMBIEN HAY QUE VERIFICAR QUE LOS CAMBIOS HAYAN SIDO GUARDADOS
    const v = !unsavedChanges();
    const r = b && v;
    updateVD(r);
  }, [validateUpdates, blocksChanges]);
  //===============validar cambio de fecha de bloque===================
  const validateChange = (i, value) => {
    //los table inputs actualizaran el valor en base a la fecha que se establezca
    let temp = [...validateUpdates];
    temp[i] = value;
    setValidateUpdates(temp);
  };
  //=======================Cambiar tipo de orden==========================
  const toggleSortedType = () => {
    //cambiar forma de ordenamiento
    if (sortType === "sorted") {
      setSortType("reversed");
    } else setSortType("sorted");
  };

  const onCLickSortBy = (i) => {
    //ordernar por atributo especifico
    const prevColValue = sortedColumn;
    if (i == prevColValue) {
      toggleSortedType();
    } else {
      setSortedColumn(i);
      setSortType("sorted");
    }
    setSortChange((sortChange) => ++sortChange);
  };
  //======================abrir modal de bloque=========================
  const onClickPen = (index) => {
    setSelectedBlock(index);
    setShowModal(true);
  };
  //====================actualizar medicinas de bloque============================
  const updateBlockSupplies = (pos, info) => {
    updateParentProps(pos, "supplies", info);
  };
  //========================actualizar alguna prop de un bloque=====================
  const updateSomeProp = (newValue, rowPos, col) => {
    updateParentProps(rowPos, col, newValue);
  };
  //=======================click boton actualizar bloque==========================
  const onClickUpdBlock = (e, blockPos) => {
    const handleUpdateBlock = async () => {
      setUpdatingBlock(true);
      const currentBlock = { ...data.blocks[blockPos] }; //copiar info del bloque
      const props = {
        interval: currentBlock.interval,
        initDate: currentBlock.initDate,
        endDate: currentBlock.endDate,
      };
      //aplicar validaciones
      //ejecutar ruta el back para actualizar bloque
      try {
        const execUpdate = await updateBlock(currentBlock.id, props);
        IS_LOCAL_ENV && console.log(execUpdate);
        setUpdatingBlock(false);
        setBlocksChanges((prev) => {
          return prev.map((b) => {
            if (b.block == currentBlock.id) {
              b.hasChanged = false;
            }
            return b;
          });
        });
        Notification({
          title: "Operación completada",
          text: `Se aplicaron los cambios`,
          type: "Success",
        });
      } catch (err) {
        setUpdatingBlock(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    handleUpdateBlock();
    //actualizar la data local para que se muestre correctamente
    //desabilitar estado de editando
  };

  return (
    <>
      <Table className="overflow-hidden">
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {tableHeader.map((columnTitle, i) => {
              return (
                <TableCell key={i} align={`${i > 0 ? "right" : ""}`}>
                  <div
                    className={` ${
                      i > 0 ? "justify-end" : "justify-start"
                    } items-center flex flex-row  text-nowrap`}
                  >
                    <span className="font-poppins font-bold text-white ">
                      {columnTitle}
                    </span>
                  </div>
                </TableCell>
              );
            })}
            <TableCell>{""}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.blocks.map((row, i) => {
            //row = info del bloque
            return (
              <TableRow
                key={i}
                className={`${
                  i % 2 == 0 ? "bg-white" : "bg-light-green"
                }  border-y-[2px] border-accent-green`}
              >
                {blockInfoProps.map((col, j) => {
                  //solo mapear props necesarias.
                  return (
                    <TableCell key={j} align={j > 0 ? "right" : ""}>
                      <div
                        className={` ${
                          j > 0 ? "justify-end" : "justify-start"
                        } flex flex-row items-center  font-poppins mr-2`}
                      >
                        {/* Columna "name" con un botón para editar */}
                        {col === "name" && (
                          <div className="flex flex-row gap-x-1 items-center">
                            <button
                              className="rounded-[50%] hover:bg-light-green-50 transition-all duration-100 p-1"
                              onClick={(e) => onClickPen(i)}
                            >
                              <TbEyeEdit className="w-[20px] h-[20px] text-accent-green" />
                            </button>
                            <span>{row[col]}</span>
                            {blocksChanges[i]?.hasChanged && (
                              <span className="text-red-400">*</span>
                            )}
                          </div>
                        )}

                        {/* Columna "interval" con un input */}
                        {col === "interval" && (
                          <span
                            onClick={() => handleCellClick(i, "interval")}
                            className="cursor-pointer"
                          >
                            {data.status == "hidden" &&
                            activeInput?.rowPos === i &&
                            activeInput.col === "interval" ? (
                              <TableInput
                                rowPos={i}
                                col={col}
                                updValue={updateSomeProp}
                                value={row[col]}
                                props={{ type: "number", min: 1 }}
                                w="w-[40px]"
                                extraText="días"
                                blocksChanges={blocksChanges}
                              />
                            ) : (
                              <span className="w-fit hover:bg-simple-gray p-[2px] rounded-[4px] hover:cursor-pointer">
                                {row[col]}
                              </span>
                            )}
                          </span>
                        )}

                        {/* Columnas "initDate" y "endDate" con un input de tipo fecha */}
                        {["initDate", "endDate"].includes(col) && (
                          <span
                            onClick={() => handleCellClick(i, col)}
                            className="cursor-pointer"
                          >
                            {data.status == "hidden" &&
                            activeInput?.rowPos === i &&
                            activeInput.col === col ? (
                              <TableInput
                                rowPos={i}
                                col={col}
                                updValue={updateSomeProp}
                                value={
                                  new Date(row[col])
                                    .toLocaleDateString("es-PE", {
                                      region: "America/Lima",
                                    })
                                    .split("T")[0]
                                }
                                props={{
                                  type: "date",
                                  min: data.initDate.split("T")[0],
                                  max:
                                    col === "initDate"
                                      ? changeIsoDateToInputFormat(
                                          data.blocks[i].endDate
                                        )
                                      : getPreviousDay(
                                          data.endDate.split("T")[0]
                                        ),
                                }}
                                dateLimits={{
                                  initDate: data.initDate,
                                  endDate: data.endDate,
                                }}
                                w="w-[135px]"
                                validateChange={validateChange}
                                blocksChanges={blocksChanges}
                              />
                            ) : (
                              <span className="w-fit hover:bg-simple-gray p-[2px] rounded-[4px] hover:cursor-pointer">
                                {new Date(row[col]).toLocaleDateString(
                                  "es-PE",
                                  { region: "America/Lima" }
                                )}
                              </span>
                            )}
                          </span>
                        )}
                      </div>
                    </TableCell>
                  );
                })}
                <TableCell align="right" className="w-fit">
                  <button
                    className={` w-fit text-sm  rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                      updatingBlock ||
                      !validateUpdates[i] ||
                      data.status != "hidden"
                        ? "bg-default-gray cursor-not-allowed"
                        : "bg-dark-green hover:bg-accent-green"
                    } `}
                    onClick={(e) => {
                      return validateUpdates[i] ? onClickUpdBlock(e, i) : null;
                    }}
                    disabled={data.status != "hidden"}
                  >
                    <div className="flex flex-row items-center gap-x-1 px-4">
                      <span className="text-nowrap">Actualizar</span>
                      <Refresh />
                    </div>
                  </button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {showModal && (
        <ModalStructure onlyBg={true}>
          <SeasonBlockCard
            supplies={supplies}
            blockPos={selectedBlock}
            onClose={() => setShowModal(false)}
            _blockInfo={data.blocks[selectedBlock]}
            updateParentInfo={updateBlockSupplies}
            seasonStatus={data.status}
          />
        </ModalStructure>
      )}
    </>
  );
};

export default SeasonTable;
